import { PreviewMessage } from '../WbAlert';
import { ProviderFilters } from './GeneralEntityPickerDialog/CommonFilter/types';
import { GeneralEntityPickerDialog } from './GeneralEntityPickerDialog/GeneralEntityPickerDialog';
import { GeneralPurposePickerContextProvider } from './GeneralPurposePickerContext';
import { MultiTextField } from './MultipleTextField';
import { SingleTextField } from './SingleTextField';
import {
  AdaptedEntity,
  BaseProps,
  GenericEntityType,
  Provider,
  TemplateEntity,
  TextFieldValue,
} from './types';

export interface EntityPickerProps extends BaseProps {
  providerMapper: Map<string, Provider<GenericEntityType[], ProviderFilters>>;
  title: string;
  description?: string | undefined;
  multiSelection?: boolean;
  availableKinds: TemplateEntity[];
  freeSolo: boolean;
  id?: string;
  onSelect: (val: any[] | undefined) => void;
  value: TextFieldValue[] | undefined;
  resolvedValues?: TextFieldValue[];
  parentTemplateRef?: string;
  templateError?: PreviewMessage;
  required?: boolean;
  disabled?: boolean;
  fetchAiData?: (data: any[]) => Promise<GenericEntityType[]>;
  formContext?: any;
  maxItems?: number;
  checkOptionDisabled?: (option: AdaptedEntity) => boolean;
}

export const WbGeneralPurposeEntityPicker = (props: EntityPickerProps) => {
  const {
    multiSelection,
    freeSolo,
    availableKinds,
    onSelect,
    resolvedValues,
    required = false,
    disabled = false,
    fetchAiData,
    formContext,
    maxItems,
    checkOptionDisabled,
    providerMapper,
    ...rest
  } = props;

  return (
    <GeneralPurposePickerContextProvider
      availableKinds={availableKinds}
      onSelect={onSelect}
      value={props.value}
      resolvedValues={resolvedValues}
      templateError={props.templateError}
      fetchAiData={fetchAiData}
      formContext={formContext}
      providerMapper={providerMapper}
      maxItems={maxItems}
      checkOptionDisabled={checkOptionDisabled}
    >
      {!multiSelection ? (
        <SingleTextField
          required={required}
          freeSolo={freeSolo}
          disabled={disabled}
          {...rest}
          value={props.value?.[0]}
          selectableEntities={availableKinds.length}
        />
      ) : (
        <MultiTextField
          freeSolo={freeSolo}
          required={required}
          disabled={disabled}
          {...rest}
          values={props.value!}
          selectableEntities={availableKinds.length}
        />
      )}

      <GeneralEntityPickerDialog {...props} />
    </GeneralPurposePickerContextProvider>
  );
};
